import {
  fetchAdmin,
  fetchAppUsers,
  fetchBoUsers,
  fetchPaymentDefaultUsers,
  fetchStudentUsers,
  fetchUser,
  fetchUserActionLogs,
  getPushTokenStatus,
} from '../queries/users.queries'

import { skipToken, useQuery } from '@tanstack/react-query'

export const useAppUsers = () =>
  useQuery({
    queryKey: ['app-users'],
    queryFn: fetchAppUsers,
  })

export const useBoUsers = () =>
  useQuery({
    queryKey: ['bo-users'],
    queryFn: fetchBoUsers,
  })

export const useUser = (userId?: number) =>
  useQuery({
    queryKey: ['user', userId],
    queryFn: userId ? () => fetchUser(userId) : skipToken,
  })

export const useAdmin = (adminId?: number) =>
  useQuery({
    queryKey: ['admin', adminId],
    queryFn: adminId ? () => fetchAdmin(adminId) : skipToken,
  })

export const usePaymentDefaultUsers = () =>
  useQuery({
    queryKey: ['payment-default-users'],
    queryFn: fetchPaymentDefaultUsers,
  })

export const useStudentUsers = () =>
  useQuery({
    queryKey: ['student-users'],
    queryFn: fetchStudentUsers,
  })

export const usePushTokenStatus = () =>
  useQuery<boolean, Error>({
    queryKey: ['push-token-status'],
    queryFn: async () => {
      const data = await getPushTokenStatus()
      return data
    },
  })

export const useUserActionLogs = (userId?: number) =>
  useQuery({
    queryKey: ['user-action-logs', userId],
    queryFn: userId ? () => fetchUserActionLogs(userId) : skipToken,
  })
